import React from "react";

// export { default as AppLayout } from "./app.layout";
export const Layout = React.lazy(() => import("./index.layout"));
export const PublicLayout = React.lazy(() => import("./public.layout"));
export const PrivateLayout = React.lazy(() => import("./private.layout"));